export var DAY_IN_MINS = 60 * 24;
export var HOUR_IN_MINS = 60;
